import React from 'react';
import './footer.css';
import { FaFacebookF, FaInstagram, FaTripadvisor } from "react-icons/fa";
import { SiTiktok } from "react-icons/si";

function Footer() {
  return (
    <footer className="footer">
      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="footer-container">
          
          {/* Company Info Section */}
          <div className="footer-section company-info">
            <div className="footer-logo">
              <h3>Eco Rich Travels</h3>
              <div className="logo-glow"></div>
            </div>
            <p className="footer-description">
              Your trusted partner for eco-friendly transportation solutions. 
              Experience luxury travel while reducing your carbon footprint.
            </p>
            <div className="social-links">

              <a href="https://web.facebook.com/profile.php?id=61575181979310&rdid=7Pr9ZjZOVBJdiItU&share_url=https%3A%2F%2Fweb.facebook.com%2Fshare%2F16Kja57W5j%3F_rdc%3D1%26_rdr#" className="social-link" aria-label="Facebook"
                  target="_blank" 
                  rel="noopener noreferrer"
                  >
                <FaFacebookF size={20} />
              </a>


              <a href="https://www.instagram.com/ecorichvilla" className="social-link" aria-label="Instagram"
                  target="_blank" 
                  rel="noopener noreferrer"
                  >
                <FaInstagram size={20} />
              </a>


              <a href="#" className="social-link" aria-label="TikTok">
                <SiTiktok size={20} />
              </a>

              <a href="#" className="social-link" aria-label="TripAdvisor">
                <FaTripadvisor size={20} />
              </a>




            </div>



                <div class="tripadvisor-text">
                  <h3>We are rated on TripAdvisor ⭐️</h3>
                  <p>
                    Guests love their time with Eco Rich Travels!  
                    Drop your review and help more travelers discover unforgettable experiences.
                  </p>
                  <a class="review-btn" href="" target="_blank">
                    Write a Review →
                  </a>
                </div>


          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/" className="footer-link">Home</a></li>
              <li><a href="/Bookings" className="footer-link">Booking</a></li>
              <li><a href="/destination" className="footer-link">Destinations</a></li>
              <li><a href="/aboutus" className="footer-link">About Us</a></li>
              <li><a href="/contactus" className="footer-link">Contact Us</a></li>

            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-title">Tour Packages</h4>
            <ul className="footer-links">
    <li><a href="/airport-pickup-drop" className="footer-link">Airport Transfer</a></li>
    <li><a href="/tour4" className="footer-link">4-Day Beach Tour</a></li>
    <li><a href="/tour6" className="footer-link">6-Day Adventure Tour</a></li>
    <li><a href="/tour7" className="footer-link">7-Day Cultural & Wildlife</a></li>
    {/* <li><a href="/tour12" className="footer-link">12-Day Explore Sri Lanka</a></li>
    <li><a href="/tour14" className="footer-link">14-Day Ultimate Journey</a></li> */}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-title">Contact Us</h4>
            <div className="contact-info">

<div className="contact-item">
  <div className="contact-icon">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
    </svg>
  </div>
  <span 
    className="contact-link"
    onClick={() => window.location.href = 'mailto:info@ecorichtravels.com'}
    style={{cursor: 'pointer'}}
  >
    info@ecorichtravels.com
  </span>
</div>

<div className="contact-item">
  <div className="contact-icon">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
    </svg>
  </div>
  <span 
    className="contact-link"
    onClick={() => window.open('https://wa.me/94742947134', '_blank')}
    style={{cursor: 'pointer'}}
  >
    +94 74 294 7134
  </span>
</div>

<div className="contact-item">
  <div className="contact-icon">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
    </svg>
  </div>
  <span 
    className="contact-link"
    onClick={() => window.open('https://maps.app.goo.gl/ru3DZ7gsoQAwpPtT9', '_blank')}
    style={{cursor: 'pointer'}}
  >
    520, Pamunugama Rd, Negombo
  </span>
</div>


            </div>
            
            {/* Newsletter Subscription */}
            {/* <div className="newsletter">
              <h5 className="newsletter-title">Stay Updated</h5>
              <div className="newsletter-form">
                <input 
                  type="email" 
                  placeholder="Enter your email" 
                  className="newsletter-input"
                />
                <button className="newsletter-btn">Subscribe</button>
              </div>
            </div> */}


          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-container">
          <div className="footer-bottom-content">
                          <p>© {new Date().getFullYear()} Eco Rich Travels. All Rights Reserved. | Designed and Developed by 
                <a 
                  className="glaxmore-link" 
                  href="https://www.glaxmore.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  &ensp; GLAXMORE
                </a>
              </p>

          </div>
        </div>
        
        {/* Animated Background Elements */}
        <div className="footer-bg-elements">
          <div className="bg-circle circle-1"></div>
          <div className="bg-circle circle-2"></div>
          <div className="bg-circle circle-3"></div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;










